import type { IConfigDeductionSlaConfigRepository } from "@src/domain/repositories/config";
import type { GetConfigDeductionSlaConfigsDTO } from "@src/domain/dto/config";

export class GetConfigDeductionSlaConfigsUseCase {
  private readonly repository: IConfigDeductionSlaConfigRepository;

  constructor(repository: IConfigDeductionSlaConfigRepository) {
    this.repository = repository;
  }

  execute(params: GetConfigDeductionSlaConfigsDTO) {
    return this.repository.getDeductionSlaConfigs(params);
  }
}
